(() => {
  const initCarousel = (root) => {
    if (root.dataset.carouselReady === 'true') return;
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    if (slides.length < 2) return;

    const controls = root.querySelector('[data-hero-controls]');
    const dots = controls ? [...controls.querySelectorAll('[data-hero-dot]')] : [];
    const previous = controls?.querySelector('[data-hero-prev]');
    const next = controls?.querySelector('[data-hero-next]');
    if (!controls || !previous || !next) return;

    root.dataset.carouselReady = 'true';
    let current = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (current < 0) current = 0;
    let timer = null;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const shouldAutoplay = root.dataset.autoplay === 'true' && !reducedMotion;
    const interval = Math.max(3000, Number(root.dataset.interval) || 5000);

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };
    const start = () => {
      stop();
      if (shouldAutoplay && !document.hidden) timer = window.setInterval(() => show(current + 1), interval);
    };

    previous.addEventListener('click', () => { show(current - 1); start(); });
    next.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); start(); }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', start);
    start();
  };

  const initAll = () => document.querySelectorAll('[data-hero-carousel]').forEach(initCarousel);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
